export const contacts = {
  complexLocation: [54.725857, 55.99678],
  companyLocation: [54.725498, 55.99761],
  workHours: ["пн-пт 9:00 - 18:00"]
}
